import * as React from "react"
import { Stack, Box, Typography } from "@mui/material"
import { Equation } from "@gillkyle/react-equation"

export default function HelpRoas() {
  return (
    <Stack spacing={0.5} sx={{ fontSize: "sm" }}>
      <Typography
        variant="h4"
        sx={{ fontWeight: 600, fontSize: "sm", paddingTop: 1.5 }}
      >
        ROAS
      </Typography>
      <Box>
        Short for {`"Return on Ad Spend"`} which is a formula of your attributed
        revenue over the cost to run the ads. You may notice there are multiple
        columns for ROAS that correspond to attribution from different sources
        (like Luz or Facebook).
      </Box>
      <Box sx={{ py: 0.5 }}>
        <Equation value="ROAS = revenue / (ad spend)" />
      </Box>
      <Box>
        This number tells you{" "}
        <b>how much you make for each dollar spent on ads</b>.
      </Box>
      <Typography
        variant="h4"
        sx={{ fontWeight: 600, fontSize: "sm", paddingTop: 1.5 }}
      >
        ROAS+
      </Typography>
      <Box>
        An improved calculation of ROAS that takes into account the COGS (
        {`"Cost of Goods Sold"`}) of products from attributed orders, in
        addition to the cost to run ads.
      </Box>
      <Box sx={{ py: 0.5 }}>
        <Equation value="ROAS Plus = revenue / (ad spend + COGS)" />
      </Box>
      <Box>
        This number tells you{" "}
        <b>how much you make for each dollar spent to earn these orders</b>.
      </Box>
    </Stack>
  )
}
